export enum EmailBodyContentType {
  Html = 1,
  Rtf = 2,
  Text = 3,
}
